import React from "react";
import {
  Edit,
  TabbedForm,
  FormTab,
  FileInput,
  FileField,
  NumberInput,
  LongTextInput,
  translate
} from "react-admin";
import { required } from "../../services/validate";

const AboutTitle = props => {
  return <span>About</span>;
};

export const AboutEdit = props => (
  <Edit title="about.about" {...props}>
    <TabbedForm {...props}>
      <FormTab label="about.tab.about">
        <FileInput
          source="about_file"
          label="about.about_name"
          accept="application/pdf"
        >
          <FileField target="_blank" source="url" title="name" />
        </FileInput>
      </FormTab>
      <FormTab label="about.tab.point">
        <NumberInput validate={[required()]} source="scan_point" step={1} />
        <NumberInput validate={[required()]} source="share_point" step={1} />
        <NumberInput validate={[required()]} source="service_point" step={1} />
      </FormTab>
      <FormTab label="about.tab.invoice">
        <LongTextInput source="invoice_to" />
        <LongTextInput source="invoice_company" />
        <LongTextInput source="invoice_address" />
        <NumberInput validate={[required()]} source="cost_member" step={1} />
        <NumberInput validate={[required()]} source="cost_scan" step={1} />
      </FormTab>
      <FormTab label="about.tab.privilege_config">
        <LongTextInput source="privilege_url" />
        <NumberInput source="privilege_appid" step={1} />
        <LongTextInput source="privilege_apikey" />
      </FormTab>
      <FormTab label="about.tab.nearby_config">
        <LongTextInput source="nearby_url" />
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/about/AboutEdit.js